<template>
  <div>
    <template v-if="info">
      <b-row>
        <b-col class="12">
          <h4 class="chr-title">
            <p class="mb-0">
              {{info.name}}
              <sup class="text-warning" v-if="starsIsNumber">
                <span v-for="star in stars" :key="star">
                  <b-icon icon="suit-heart-fill" class="text-danger ml-1" font-scale="0.7"/>
                </span>
              </sup>
              <strong class="ml-2" v-else>
                <small v-if="!starsIsNumber" class="text-danger">{{ info.class }}</small>
                <small class="text-warning">{{ info.extraClass }}</small>
              </strong>
            </p>
          </h4>
        </b-col>
      </b-row>
      <b-row class="my-3" v-if="info.description || info.url || (info.descriptions && info.descriptions.length)">
        <b-col sm="12">
          <!-- slot - insert summary only for booking view - must hide .carousel-container v-if/v-else on info modal-->
          <slot v-if="isBook"></slot>
          <div class="carousel-container" v-else>
            <div class="carousel-wrapper">
              <img :src="info.images[0].url" class="print-only data-url-replace" style="height:250px;" v-if="info.images.length"/>
              <b-card no-body class="noPrint removeFromPrint">
                <b-carousel
                  id="carousel"
                  controls
                  indicators
                  v-if="info.images && info.images.length">
                  <b-carousel-slide v-for="(image,imageIndex) in info.images" :key="imageIndex">
                    <template slot="img">
                      <img :src="image.url" class="img-fluid w-100 d-block"/>
                    </template>
                  </b-carousel-slide>
                </b-carousel>
              </b-card>
            </div>
          </div>
          <slot name="hotelDetails"></slot>
          <h5 class="modal-title my-2 pb-2"><b v-translate>Description</b></h5>
          <div class="mt-2">
            <p style="text-align:justify;" v-if="info.descriptionIsHtml" v-html="info.description"></p>
            <p style="text-align:justify; white-space: pre-line;" v-else>{{info.description }}</p>
            <div v-for="(desc, descIndex) in info.descriptions" :key="'desc' + descIndex">
              <h6 class="modal-title">{{ desc.label }}</h6>
              <p v-html="desc.text"></p>
            </div>
            <div v-if="info.url">
              <small>
                <a :href="info.url" target="_blank">{{ info.url }}</a>
              </small>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <b-row v-else>
      <b-col md="12" class="text-center pt-3">
        <b-aspect aspect="10">
          <b-spinner type="grow" label="Se incarca"></b-spinner>
          <p v-translate>Please wait...</p>
        </b-aspect>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
  .print-only {
    display: none!important;
  }
</style>

<script>

export default {
  name: 'HotelInfo',
  props: ['info'],
  data () {
    return {
      map: null,
      button: {
        text: 'show more'
      }
    }
  },
  computed: {
    starsIsNumber () {
      // Try converting the string to an integer
      const intValue = parseInt(this.info.class, 10) // Base 10 for decimal system

      // Check if it's a valid integer and not NaN
      return !isNaN(intValue) && Number.isInteger(intValue)
    },
    stars () {
      return parseInt(this.info.class, 10)
    },
    isBook () {
      return this.$route.name === 'Private/Package/Book'
    }
  }
}
</script>
